import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { leagueSlugFromPath } from "../../utils/leaguePath";

const getDeviceAndBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let device_type = "Unknown";
  let device_name = "Unknown";
  console.log(userAgent);
  if (userAgent.includes("Windows")) {
    device_type = "W";
  } else if (userAgent.includes("Macintosh")) {
    device_type = "W";
  } else if (userAgent.includes("Linux")) {
    device_type = "W";
  }
  if (userAgent.includes("Chrome")) {
    device_name = "Chrome";
  } else if (userAgent.includes("Safari")) {
    device_name = "Safari";
  } else if (userAgent.includes("Firefox")) {
    device_name = "Firefox";
  } else if (userAgent.includes("Edge")) {
    device_name = "Edge";
  } else if (userAgent.includes("Opera")) {
    device_name = "Opera";
  }
  if (/Android/i.test(userAgent)) {
    device_type = "A";
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    device_type = "I";
  } else {
    device_type = "W";
  }
  return { device_type, device_name };
};

function generateRandomToken() {
  const token = localStorage.getItem("FCM-WEB");
  console.log(token);
  return token;
}

const path = window.location.pathname;

// const API_BASE_URL = process.env.REACT_APP_BASE_URL;
const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
const fcmToken = localStorage.getItem("FCM");
const deviceName = localStorage.getItem("DeviceName");
const deviceType = localStorage.getItem("DeviceType");
const deviceToken = localStorage.getItem("DeviceToken");

//console.log(fcmToken, deviceName, deviceType, deviceToken, "fcmcmcmmc");
let fcmHeaderValue, deviceNameValue, deviceTypeValue, deviceTokenValue;

if (fcmToken !== null && fcmToken !== undefined) {
  fcmHeaderValue = fcmToken;
} else {
  fcmHeaderValue = generateRandomToken();
  if (fcmHeaderValue == "" || fcmHeaderValue == null) {
    localStorage.getItem("FCM-WEB");
  }
  //console.log(fcmHeaderValue, "fcfcfcfcs");
  // fcmHeaderValue = localStorage.get("FCM-WEB") || "" // Default value if FCM token is not present
}
if (deviceName != null && deviceName != undefined) {
  console.log("present device name");
  deviceNameValue = deviceName;
} else {
  console.log("notpresent name");
  deviceNameValue = getDeviceAndBrowserInfo().device_name; // Default value if DeviceName is not present
}
if (deviceType != null && deviceType != undefined) {
  console.log("present device type");
  deviceTypeValue = deviceType;
} else {
  console.log(" present device type not");
  deviceTypeValue = getDeviceAndBrowserInfo().device_type; // Default value if DeviceType is not present
}
if (deviceToken !== null && deviceToken !== undefined) {
  console.log("present device Token");
  deviceTokenValue = deviceToken;
} else {
  const storedDeviceId = localStorage.getItem("deviceId");
  if (!storedDeviceId) {
    const generatedDeviceId = uuidv4();
    localStorage.setItem("deviceId", generatedDeviceId);
    deviceTokenValue = generatedDeviceId;
  } else {
    deviceTokenValue = storedDeviceId;
  }
}

function generateRandomToken1(length) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    token += characters.charAt(randomIndex);
  }
  return token;
}

const token = generateRandomToken1(20);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization:
      "Bearer " + localStorage.getItem("accessToken") &&
      JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token,
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue
      ? deviceNameValue
      : localStorage.getItem("DeviceName"),
    "Device-Token": deviceTokenValue
      ? deviceTokenValue
      : localStorage.getItem("DeviceToken"),

    "App-Version": "1.0.0",
    Timezone: timeZone,
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Any status codes that fall outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // Handle the 401 error
      console.log(error.response.data.message, "responsesesese");
      // Backend message.UNAUTHORIZED_ACCESS (expired/invalid token); other 401 messages show as before.
      toast.error(
        error.response.data.message ===
          "Your session has expired for security reasons. Please log in again to continue using the app."
          ? "Your session expired. Log in again."
          : error.response.data.message
      );
      console.error("Unauthorized! Logging out...");
      // Here, implement your logic for clearing local storage or cookies that hold authentication info
      const onboardingSeen = localStorage.getItem("qushi_onboarding_seen");
      localStorage.clear();
      if (onboardingSeen) localStorage.setItem("qushi_onboarding_seen", onboardingSeen);
      // Redirect the user to the login page
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);

// ---------------------------------------------------------------------------
// League scoping for watchlist requests.
//
// THREE endpoints, and only three. Client, "League Watchlist: launch behavior":
//
//   "Keep the existing QUSHi Watchlist system unchanged inside League Play.
//    Users can continue creating and managing their normal personal
//    watchlists… The watchlist itself is global. How it is used in Trade is
//    contextual… The one thing I would tell dev is do not automatically name or
//    mark a list as belonging to a league. If the user creates a list inside
//    League Play, it is simply another My List that they own everywhere."
//
// This list used to also carry get-watchlists, get-user-watchlists,
// get-watchlists-search-page and create-watchlist, which split a member's LISTS
// per league under an earlier reading of Rev 2's global rule 6. The client has
// now settled that question the other way: the lists are global, so those four
// are gone from here and read and write the one global set again.
//
// What remains is the one thing the client explicitly kept separate: "League
// Trade wheel selections must not change the user's main QUSHi Trade wheel."
// That is the DEFAULT — which list powers the wheel — so the three
// default-watchlist endpoints still carry the league, and the backend keeps a
// league's choice in its own row (game_default_watchlists) instead of
// overwriting users.default_watchlist_id.
//
// Reading the league off the URL at request time cannot miss a call site, needs
// no lifecycle, and cannot go stale, because the URL IS the scope.
const LEAGUE_SCOPED_WATCHLIST_ENDPOINTS = new Set([
  "user/default-watchlist",
  "user/set-default-watchlist",
  "user/default-watchlist-items",
]);

axiosInstance.interceptors.request.use((config) => {
  try {
    const slug = leagueSlugFromPath(window.location.pathname);
    if (!slug) return config; // main site — send nothing, behave exactly as before

    const endpoint = String(config.url || "")
      .split("?")[0]
      .replace(API_BASE_URL, "")
      .replace(/^\/+/, "");

    if (!LEAGUE_SCOPED_WATCHLIST_ENDPOINTS.has(endpoint)) return config;

    // Always a query param, never the body: Laravel's $request->input() reads
    // the query string on POSTs too, and touching the body risks disturbing a
    // payload some other screen depends on.
    config.params = { ...(config.params || {}), league: slug };
  } catch (e) {
    // Scoping is an enhancement — never let it stop a request going out.
    console.error("League watchlist scope failed:", e);
  }
  return config;
});

// Retrieve fcmToken from localStorage or use default value '12345'

export const signUpApi = async (body) => {
  console.log(body,'body i am getting is');

  const response = await axiosInstance.post(`${API_BASE_URL}signup`, body);
  return response;
};

export const getCountries = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}getCountries`, body);
  return response;
};

export const login = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}login`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};
export const sendotp = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}send-otp`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const verifyotp = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}verify-otp`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const SocialLogin = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}social-login`,
    body,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};

export const forgotPassword = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}forgot-password`,
    body,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};

export const resetPasswordWithToken = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}reset-password-token`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  );
  return response;
};

export const getProfile = async (id, game_id = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-profile`,
      {
        user_id: id,
        game_id: game_id
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error get in profile:", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getProfileImage = async (id, game_id = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-profile-image`,
      {
        user_id: id,
        game_id: game_id
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error get in profile:", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};

export const updateProfile = async (body) => {
  console.log(body, "bo");
  // Create a FormData object
  const formData = new FormData();

  const imagePath = body?.image;
  console.log(imagePath, "imagepath");
  if (imagePath && imagePath.length > 0 && imagePath !== "null") {
    formData.append("image", imagePath);
  }
  formData.append("full_name", body.full_name);
  formData.append("email", body.email);
  formData.append("country_code", body.countryCode);
  formData.append("phone", body.phone);
  formData.append("biography", body.biography);
  formData.append("trading_type_id", body.trading_type_id);
  formData.append("subscription_plan_amount", body.subscription_plan_amount);
  formData.append("is_chat_paid", body.chat_type);
  formData.append("title", body.title);
  formData.append("link", body.link);
  formData.append("user_name", body.user_name);
  formData.append("date_of_birth", body.date_of_birth);
  formData.append("country_of_origin", body.country_of_origin);

  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}update-profile`,
      formData,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error updating profile:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const deleteAdminsistrator = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}deleteAdministrator`,
    body,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};

export const changePassword = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}change-password`,
      body,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error changing password:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const logout = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}logout`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getpost = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-post`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const createPost = async (body) => {
  console.log('body is',body);
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-update-post`,
      body,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getNotifications = async (page, limit = 10) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-notification`,
      { page: page, limit: limit },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting notifications:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getSettings = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}app-settings`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting settings:", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getS3 = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}s3-token`, // URL is the first argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting s3 token:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const s3Upload = async (newImages) => {
  console.log(newImages, "newnew");
  console.log(JSON.stringify(newImages), "newnew");

  const formData = new FormData();
  newImages.forEach((img, index) => {
    console.log(JSON.stringify(img, "img"));
    console.log(`Image ${index + 1}:`, img.blob);
    console.log(`Image ${index + 1}:`, JSON.stringify(img.blob));

    // Append each image blob to formData with the key 'files[]'
    formData.append("files[]", img.blob);
  });
  const headers = {
    Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue,
    "Device-Token": deviceTokenValue,
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token, // Use the default value if fcmToken is null or undefined
    "App-Version": "1.0.0",
    Timezone: timeZone,
  };
  console.log(formData);
  try {
    const response = await axios.post(`${API_BASE_URL}s3-upload`, formData, {
      headers: {
        ...headers,
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data", // Let FormData handle Content-Type
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading to s3:", error);
    throw error; // Handle this according to your application's needs
  }
};

// export const getAllPost = async (search_term, params) => {
//  console.log(search_term,'search_term');
//  console.log(params,'params');
//   const body = {
//     page:params,
//     limit: 10,
//     search_term: search_term ? search_term : "",
//   };
//  console.log(body,'----------sdfsfdsfgsfg---------');
//     if (params.game_id) {
//     body.game_id = params.game_id;
//   }

//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}get-all-post`,
//       body, // Pass the 'body' object as the second argument
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token, // Use the default value if fcmToken is null or undefined
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     console.error("Error getting all posts:", error);
//     throw error;
//   }
// };


export const getAllPost = async (search_term, page) => {
const body = {
  page: search_term ? page : page.page, // Default is page.page; if search_term is set, use page
  limit: 10,
  search_term: search_term || "", // Default is an empty string
};
  // Client Rev 3, 9: "League posts should always remain separate from the main
  // feed." The league feed screen has ALWAYS built `params.game_id` (FeedPage's
  // fetchPost and fetchMorePost both set it) — this function simply never put it
  // on the wire, so every caller got the same unscoped "all posts" response and
  // the league feed filtered it in the browser. That made the browser the only
  // thing keeping a league's conversation off the main feed, and it also meant a
  // league feed paginated through SITEWIDE posts to find its own.
  // The league now asks for itself, and the server answers with just that league
  // (see PostController::geAllPosts).
  if (page && typeof page === "object" && page.game_id) {
    body.game_id = page.game_id;
  }
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-all-post`,
      body, // Pass the 'body' object as the second argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};


export const getMyPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-all-post`,
      id,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};

export const getPaidPost = async (dataObj) => {
  try {
    const body = {
      user_id: dataObj?.user_id,
      post_status: dataObj?.post_status,
      page: dataObj.page,
      limit: 10,
    };
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-all-post`,
      body, // Pass the 'body' object as the second argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};

export const likeDislike = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}like-dislike-post`, // URL is the first argument
      { post_id: id }, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      } // Configuration object is the third argument
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error like dislike :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const addComment = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}post-comment`, // URL is the first argument
      body, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      } // Configuration object is the third argument
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in add comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getComment = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-comment`, // URL is the first argument
      { post_id: id }, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in add comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const deletePost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-post`, // URL is the first argument
      { post_id: id }, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete post :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const pinPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}pin-post`,
      { post_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error pin post :", error);
    throw error;
  }
};
export const getLeaderBoard = async (game_id = null) => {
  const body = {
    page: 1,
    limit: 100,
    game_id: game_id
  };
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}leaderboard`,
      body, // Pass the 'body' object as the second argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error get Leaderboard :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getUserFollowers = async (userId) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-follower-list`,
      { list_type: 1,
       receiver_id: userId, },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};


// `gameId` is optional and OMITTED when absent — the endpoint reads a missing
// game_id as "the main QUSHi record" (performance_histories.game_id IS NULL),
// which is exactly the behaviour every existing caller already relies on.
export const getUserPerformance = async (userId,startDate,endDate,gameId = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-user-performance`,
      {
       userId: userId, start_date:startDate,end_date:endDate,
       ...(gameId ? { game_id: gameId } : {})},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};


export const deleteComment = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-post-comment`,
      { id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const followUnfollow = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}friend-request`,
      body,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const repostPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}repost`,
      {
        repost_id: id,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const undoRepostPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}undo-post`,
      {
        post_id: id,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const tradingType = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-trading-type`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};
export const chatList = async (type) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-chat-list`,
      {
        chat_type: type,
        limit: 100,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const chatDetails = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-chat-detail`,
      data?.receiver_id
        ? {
            receiver_id: data?.receiver_id,
            page: 1,
            limit: 200,
            ...(data?.game_id && { game_id: data.game_id }),
          }
        : data?.chat_group_id
        ? { chat_group_id: data?.chat_group_id, page: 1, limit: 200, ...(data?.game_id && { game_id: data.game_id }),  }
        : "",
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting chat details :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
// export const joinChat = async (gid, id) => {
//
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}join-chat`, { chat_group_id: gid, type: 1 }
//     );

//     return response;
//   } catch (error) {
//     // Handle error
//     console.error('Error getting in joining chat :', error);
//     throw error; // You might want to handle this differently based on your application's needs
//   }
// };
// export const sendMessage = async (mess, id) => {
//
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}send-message`, { message: mess, receiver_id: id, type: 1 }
//     );

//     return response;
//   } catch (error) {
//     // Handle error
//     console.error('Error getting in joining chat :', error);
//     throw error; // You might want to handle this differently based on your application's needs
//   }
// };
export const deleteChat = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-chat`,
      { chat_group_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in delete chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteMessage = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-message`,
      {
        body,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const sendNoti = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}send-notification`,
      { body },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getSavedPost = async (e) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-saved-post`,
      { page: e },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const savePost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}save-post`,
      {
        post_id: id,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteSavePost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-saved-post`,
      { saved_post_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const createPaymentApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}payment-method`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getPaymentCardsApi = async () => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-payment-method`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};


export const createPaymentIntent = async () =>{
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-payment-intent`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in payment intent :", error);
  }
}


export const checkTransactionStatus = async (paymentId) =>{
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}check-transaction-status`,
      {payment_id:paymentId},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in payment intent :", error);
  }
}

export const resetPortfolio = async (paymentId) =>{
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}reset-portfolio`,
      {payment_id:paymentId},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in payment intent :", error);
  }
}

export const deleteCardApi = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-payment-method
      `,
      { payment_method_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const makePaymentApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}payment
      `,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const setPrimaryMethod = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}set-primary-method
      `,
      { payment_method_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getSubscriptionMethod = async () => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-subscription
      `,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const cancelSubscription = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}cancle-subscription
      `,
      { subscription_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

// export const searchStocksApi = async (data) => {
//   console.log(data,'data getting in function');
//   try {
//     const response = await axiosInstance.get(
//       `${API_BASE_URL}${
//         window.location.pathname == "/auth/trending-stocks"
//           ? "trending-stocks"
//           : "stocks/search"
//       }${data ? "?search=" + data : ""}`,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token, // Use the default value if fcmToken is null or undefined
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     // Handle error
//     console.error("Error getting trading type :", error);
//     throw error; // You might want to handle this differently based on your application's needs
//   }
// };


export const searchStocksApi = async (data) => {
  console.log(data, 'data getting in function');

  const { search, category } = data || {};
  const queryParams = [];

  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  if (category) queryParams.push(`category=${encodeURIComponent(category)}`);

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}${
        window.location.pathname === "/auth/trending-stocks"
          ? "trending-stocks"
          : "stocks/search"
      }${queryString}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type:", error);
    throw error;
  }
};


export const createConnectAccountApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-connect-account`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const voteMarket = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-vote`,
      {
        vote_type: data,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const marketSentiment = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-market-sentiment`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
// export const searchStock = async (data) => {
//   try {
//     const response = await axiosInstance.get(
//       `${API_BASE_URL}stock-details?ticker=${data}`,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token, // Use the default value if fcmToken is null or undefined
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     // Handle error
//     console.error("Error getting trading type :", error);
//     throw error; // You might want to handle this differently based on your application's needs
//   }
// };

export const searchStock = async ({ search, category }) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}stock-details?ticker=${search}&category=${category}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error;
  }
};


export const getOrder = async (data, id, game_id = null) => {
  try {
    // const requestBody = {
    //   type: data,
    // };

    const requestBody = {
      type: data,
      include_portfolio: false, // fast pass
    };

    if (id) {
      requestBody.user_id = id; // Include user_id only if id is available
    }

    if (game_id) {
      requestBody.game_id = game_id;
    }

    const response = await axiosInstance.post(
      `${API_BASE_URL}get-order`,
      requestBody,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in getOrder:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const fetchPortfolioMetrics = async ({ user_id = null, game_id = null } = {}) => {
  try {
    const requestBody = {};
    if (user_id) requestBody.user_id = user_id;
    if (game_id) requestBody.game_id = game_id;

    const response = await axiosInstance.post(
      `${API_BASE_URL}portfolio/metrics`,
      requestBody,
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token":
            localStorage.getItem("FCM-WEB") ??
            localStorage.getItem("FCM") ??
            token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error in fetchPortfolioMetrics:", error);
    throw error;
  }
};

export const createOrder = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-update-order`,

      data,

      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const clearNotification = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}clear-badge`,
      { type: data },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getChartStockDetails = async ({ ticker, category }) => {
  console.log(ticker,'ticker in api');
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}chart-stock-details?ticker=${ticker}&category=${category}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type:", error);
    throw error;
  }
};


export const s3SingleUpload = async (newImages) => {
  const formData = new FormData();
  formData.append("files[]", newImages);
  const headers = {
    Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue,
    "Device-Token": deviceTokenValue,
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token,
    "App-Version": "1.0.0",
    Timezone: timeZone,
  };

  try {
    const response = await axios.post(`${API_BASE_URL}s3-upload`, formData, {
      headers: {
        ...headers,
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data", // Let FormData handle Content-Type
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading to s3:", error);
    throw error; // Handle this according to your application's needs
  }
};

export const saveChart = async (data, ticker) => {
  try {
    const formData = new FormData();
    formData.append("image_json", JSON.stringify(data));
    formData.append("ticker", ticker);
    const response = await axiosInstance.post(
      `${API_BASE_URL}save-chart`,
      formData,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getSavedCharts = async () => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-saved-chart`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const cancelOrderApi = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}order-cancel`,
      { order_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const addChartNotification = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}add-notification`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteAccount = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}delete-account`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

// Get help / contact support. `data` is the full payload built on the Get help
// screen (name, username, email, phone, app_version, device, os, timestamp,
// topic, message). NOTE: the `help-request` backend endpoint must exist for this
// to succeed — confirm/adjust the route with the API team.
export const sendHelpMessage = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}help-request`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error sending help message:", error);
    throw error;
  }
};

// "Request a Club Challenge" — the two-step modal on League Play. `data` is
// { challenge_type: "rival" | "anyone", club_name, contact_preference }. The
// user's own name, email and phone are read from their account server-side, so
// they are deliberately NOT sent from here.
export const requestClubChallenge = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}club-challenge-request`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error sending club challenge request:", error);
    throw error;
  }
};

export const reportPostApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}report-post`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const blockUnblockUserApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}block-unblock-user`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const checkUsername = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}verify-user-name`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getFollowersListApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-friend-list`,
      { list_type: 1 },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};

export const shareSavedChartApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}share-saved-chart`,
      { chart_id: data?.chart_id, users: data?.users },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const sentimentReportApi = async (data) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}sentiment-report
      `,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const shareCartAsPostApi = async (chart_id, inputValue,game_id = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}share-as-post`,
      { chart_id: chart_id, description: inputValue,...(game_id && { game_id: game_id }), },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteSavedChart = async (chart_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-saved-chart`,
      { id: chart_id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const legalDisclaimerApi = async (disclaimer) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}legal-disclaimer`,
      { disclaimer: "1" },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

//Game Contest Api


export const storeTempImage = async (filePath) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}upload-temp`,
      { filePath },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "application/json",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response.data.url; // Return the public URL
  } catch (error) {
    console.error("Error storing temporary image:", error);
    throw error;
  }
};





export const gameImageUpload = async (newImages) => {
  console.log(newImages, "newnew");
  console.log(JSON.stringify(newImages), "newnew");

  const formData = new FormData();
  newImages.forEach((img, index) => {
    console.log(JSON.stringify(img, "img"));
    console.log(`Image ${index + 1}:`, img.blob);
    console.log(`Image ${index + 1}:`, JSON.stringify(img.blob));

    // Append each image blob to formData with the key 'files[]'
    formData.append("files[]", img.blob);
  });
  const headers = {
    Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue,
    "Device-Token": deviceTokenValue,
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token, // Use the default value if fcmToken is null or undefined
    "App-Version": "1.0.0",
    Timezone: timeZone,
  };
  try {
    const response = await axios.post(`${API_BASE_URL}uploadForGame`, formData, {
      headers: {
        ...headers,
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data", // Let FormData handle Content-Type
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading to s3:", error);
    throw error; // Handle this according to your application's needs
  }
};


export const getAllGame = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-all-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};


export const getMyGame = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-my-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};

// `signal` lets a screen abort this request when it unmounts. The Cash Games
// View All screen re-fetches on mount and on pull-to-refresh, and without a
// signal a slow in-flight request could land after the user had navigated away
// and set state on a component that no longer exists.
export const getCashLeague = async ({ signal } = {}) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-cash-game`,
      {
        signal,
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};

export const getMemberGame = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-member-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};

export const getAllGames = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-all-my-games`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};


export const getVanityUrl = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-vanity-url`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting vanity url:", error);
    throw error;
  }
};




export const CreateGames = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}create-game`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const editGame = async (body) => {

  const response = await axiosInstance.post(`${API_BASE_URL}edit-game`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};


export const deleteGameImage = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}delete-game-image`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};


export const getgame = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-game`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const updatePhoneNumber = async (phone,country_of_origin) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}update-phone-number`,
      { phone ,country_of_origin },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("accessToken"))}`,
          "Content-Type": "application/json",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token":
            localStorage.getItem("FCM-WEB") ||
            localStorage.getItem("FCM") ||
            token, // Use default if FCM token is null
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    if (response.status === 200) {
      return response.data; // ✅ Return the actual data
    } else {
      throw new Error(response.data.message || "Failed to update phone number.");
    }
  } catch (error) {
    console.error("Error updating phone number:", error.response?.data || error);
    throw error;
  }
};


export const getGameByInviteCode = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-game-by-invite-code`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const joingame = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}join-game`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getGameFromSlug = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-game-from-slug`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};



//Invitations
export const sendInvitation = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}send-invitation`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};


export const getGameFromToken = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}game-token`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getInvitationFromToken = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}verfiy-token`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const updateInvitationStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}update-invitation-status`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const declineInvitation = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}decline-invitation`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};



export const acceptInvitation = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}accept-invitation`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const passwordCheck = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}validate-password`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};



//Sign In Apple Integration

export const sendAppleWebResponse = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}send-apple-response`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const checkCashUser = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}check-cash-user`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getTradingVideos = async (category_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-videos`,
      category_id,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};

export const incrementView = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-view`,
      id,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};


export const getTradingSingleVideos = async (category_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-single-videos`,
      category_id
    );
    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};

export const incrementSingleView = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-single-view`,
      id,
    );
    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};

export const getSingleVideo = async (videoId) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-video`,
      videoId,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};


export const trackPageView = async () => {
  try {
    const response = await axiosInstance.get(`/track-pageview`, {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : null,
        "App-Version": "1.0.0",
        Timezone: timeZone,
        "Source-Page": window.location.href, // ✅ Full current URL
      },
    });

    return response;
  } catch (error) {
    console.error("Error in PageView tracking:", error);
  }
};


export const trackViewContent = async () => {
  try {
    const response = await axiosInstance.get(`/track-viewcontent`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : null,
        "App-Version": "1.0.0",
        Timezone: timeZone,
        "Source-Page": window.location.href, // now the full URL
      },
    });

    return response;
  } catch (error) {
    console.error("Error in ViewContent tracking:", error);
  }
};


// export const stockSearch = async (data) => {
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}stocks-search`,
//       {
//         category: data.category,
//         query: data.query,
//       },
//       {
//         headers: {
//           Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token,
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     console.error("Error getting trading type:", error);
//   }
// };


export const stockSearch = async (data, signal) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}stocks-search`,
      {
        category: data.category,
        query: data.query,
      },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
        signal, // ✅ NEW: Axios will use this to cancel
      }
    );

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.warn("Request canceled:", error.message);
    } else {
      console.error("Error getting trading type:", error);
    }
    throw error;
  }
};


export const stockFmvData = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}stock-fmv`,
      {
        category: data.category,
        stockName: data.query,
      },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type:", error);
  }
};

export const chartstockFmvData = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}chart-stock-fmv`,
      {
        category: data.category,
        stockName: data.ticker,
      },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type:", error);
  }
};

// export const shareVideo = async (data) => {
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}share-video`,
//       data,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token, // Use the default value if fcmToken is null or undefined
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     console.error("Error getting all trading videos:", error);
//     throw error;
//   }
// };

// Watchlist

export const createWatchlist = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}create-watchlist`,
    body,
    {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "application/json",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};


export const getWatchlists = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}get-watchlists`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

// export const getWatchlistsSearchPage = async () => {
//   const response = await axiosInstance.get(`${API_BASE_URL}get-watchlists-search-page`, {
//     headers: {
//       Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//       "Device-Type": deviceTypeValue,
//       "Device-Name": deviceNameValue,
//       "Device-Token": deviceTokenValue,
//       "Fcm-Token": localStorage.getItem("FCM-WEB")
//         ? localStorage.getItem("FCM-WEB")
//         : localStorage.getItem("FCM")
//         ? localStorage.getItem("FCM")
//         : token,
//       "App-Version": "1.0.0",
//       Timezone: timeZone,
//     },
//   });
//   return response;
// };

// `symbolsOnly` asks the server to skip the per-row Polygon price lookups and
// answer with the rows alone. League eligibility only needs to know which
// assets a list holds, and paying two external round trips per row for prices
// it discards is what made the Watchlist and Trade screens hang for the client.
// An older backend simply ignores the flag and returns the enriched rows, which
// still answer the question — so this is safe to ship ahead of the API.
export const getWatchlistItems = async (idOrKey, page = 1, limit = 10, { symbolsOnly = false } = {}) => {
  const lean = symbolsOnly ? "&symbols_only=1" : "";
  const url =
    typeof idOrKey === "string"
      ? `${API_BASE_URL}get-watchlist-items?default=${idOrKey}&page=${page}&limit=${limit}${lean}`
      : `${API_BASE_URL}get-watchlist-items/${idOrKey}?page=${page}&limit=${limit}${lean}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB") || localStorage.getItem("FCM") || token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};


export const addStockToWatchlists = async (symbol, watchlistIds) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}add-to-watchlists`,
      {
        symbol: symbol, // stock ticker
        watchlist_ids: watchlistIds, // array of IDs
      },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response.data; // response from backend
  } catch (error) {
    console.error("Error adding stock to watchlists:", error);
    throw error;
  }
};


export const deleteWatchlist = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-watchlist`, // Laravel endpoint
      { watchlist_id: id },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting watchlist:", error);
    throw error;
  }
};


export const deleteWatchlistItem = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-watchlist-item`,
      { watchlist_item_id: id },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting watchlist item:", error);
    throw error;
  }
};



export const getParentWatchlists = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}get-parent-watchlists`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const getWatchlistsSearchPage = async (parentId = null) => {
  const url = `${API_BASE_URL}get-watchlists-search-page${parentId ? `?parent_id=${parentId}` : ""}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getUserWatchlists = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}get-user-watchlists`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const deleteWatchlists = async (watchlistIds) => {

  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-user-watchlists`,
      {
        watchlist_ids: watchlistIds, // array of IDs
      },
      {
        headers: {
          Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response.data; // response from backend
  } catch (error) {
    console.error("Error adding stock to watchlists:", error);
    throw error;
  }
};

// Persist the order of the user's personal (parent 4) lists.
export const reorderWatchlists = async (orderedIds) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}reorder-watchlists`,
    { ordered_ids: orderedIds },
    {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response.data;
};

// Persist the order of the items within a list the user owns.
export const reorderWatchlistItems = async (watchlistId, orderedIds) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}reorder-watchlist-items`,
    { watchlist_id: watchlistId, ordered_ids: orderedIds },
    {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response.data;
};

// Rename a personal list the user owns.
export const renameWatchlist = async (watchlistId, name) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}rename-watchlist`,
    { watchlist_id: watchlistId, name },
    {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response.data;
};

export const generateReferralCode = async () => {
  const response = await axiosInstance.post(`${API_BASE_URL}referral/generate`, {}, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response.data;
};

export const getUserReferralCode = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}referral/code`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};


// api.js or leaderboardApi.js
export const getLeaderboardData = async (type = "day") => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}get-top-performers?period=${type}`,
    {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token":
          localStorage.getItem("FCM-WEB") ||
          localStorage.getItem("FCM") ||
          token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );

  return response;
};

export const getUserCoins = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}get-user-coins`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getUserCoinsHistory = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}get-user-coins-history`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getGuideStatus = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}guide-status`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};


export const markGuideAsShown = async () => {
  const response = await axiosInstance.post(`${API_BASE_URL}mark-guide-shown`, {}, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getGuideStatusMobile = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}guide-status-mobile`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};


export const markGuideAsShownMobile = async () => {
  const response = await axiosInstance.post(`${API_BASE_URL}mark-guide-shown-mobile`, {}, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};


export const getGuideSetting = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}guide-settings`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};


export const updateGuideSettings = async (payload) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}update-guide-settings`,
    payload,
    {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token":
          localStorage.getItem("FCM-WEB") ||
          localStorage.getItem("FCM") ||
          token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );

  return response;
};


export const getUserDefaultWatchlist = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}user/default-watchlist`,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token":
          localStorage.getItem("FCM-WEB") ||
          localStorage.getItem("FCM") ||
          token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );

  return response;
};

export const setUserDefaultWatchlist = async (payload) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}user/set-default-watchlist`,
    payload,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token":
          localStorage.getItem("FCM-WEB") ||
          localStorage.getItem("FCM") ||
          token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );

  return response;
};


export const getUserDefaultWatchlistItems = async () => {
  const response = await axiosInstance.get(
    `${API_BASE_URL}user/default-watchlist-items`,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token":
          localStorage.getItem("FCM-WEB") ||
          localStorage.getItem("FCM") ||
          token,
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );

  return response;
};


export const getBollingerBandsDataNew = async (
  symbol = "AAPL",
  period = "hour",
  length = 5,
  standardDeviation = 2,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  let url = `${API_BASE_URL}bollingernew?symbol=${symbol}&period=${period}&length=${length}&standard_deviation=${standardDeviation}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }&frontend=Mobile`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (limit) url += `&limit=${limit}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getSMADataNew = async (
  symbol = "AAPL",
  period = "hour",
  length = 10,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  let url = `${API_BASE_URL}sma?symbol=${symbol}&period=${period}&length=${length}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }&frontend=Mobile`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (limit) url += `&limit=${limit}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getEMADataNew = async (
  symbol = "AAPL",
  period = "hour",
  length = 14,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  let url = `${API_BASE_URL}ema?symbol=${symbol}&period=${period}&length=${length}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }&frontend=Mobile`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (limit) url += `&limit=${limit}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getPsarDataNew = async (
  symbol = "AAPL",
  period = "hour",
  initialAcceleration = 0.02,
  acceleration = 0.02,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  let url = `${API_BASE_URL}psar?symbol=${symbol}&period=${period}&initial_acceleration=${initialAcceleration}&acceleration=${acceleration}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }&frontend=Mobile`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (limit) url += `&limit=${limit}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getAdlDataNew = async (
  symbol = "AAPL",
  period = "hour",
  multiplier,
  startDate,
  endDate,
  limit
) => {
  let url = `${API_BASE_URL}adl?symbol=${symbol}&period=${period}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }&frontend=Mobile`;

  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (limit) url += `&limit=${limit}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};

export const getADXDataNew = async (
  symbol = "AAPL",
  period = "hour",
  length = 10,
  scalar = 100,
  drift = 1,
  lensig = 14,
  multiplier,
  startDate,
  endDate,
  limit
) => {
  let url = `${API_BASE_URL}adx?symbol=${symbol}&period=${period}&length=${length}&scalar=${scalar}&drift=${drift}&lensig=${lensig}${
    multiplier ? `&multiplier=${multiplier}` : ""
  }&frontend=Mobile`;

  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (limit) url += `&limit=${limit}`;

  const response = await axiosInstance.get(url, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });

  return response;
};
export const getLinkPreview = async (url) => {
  const formData = new FormData();
  formData.append("url", url);
  const response = await axiosInstance.post(`${API_BASE_URL}link-preview`, formData, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") ||
        localStorage.getItem("FCM") ||
        token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response.data?.data || response.data;
};

// Home Markets strip: starting prices + the reference each change % is measured
// against. Live prices stream separately over the Polygon websocket.
export const getMarketStrip = async () => {
  const response = await axiosInstance.get(`${API_BASE_URL}market-strip`, {
    headers: {
      Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "application/json",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token":
        localStorage.getItem("FCM-WEB") || localStorage.getItem("FCM") || token,
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response.data?.data || null;
};
